/* ==========================================================================
  main.js
========================================================================== */

/**
 * Responsive videos
 */
fitvids();


// comment help
var comment_help = document.querySelector('.comment-tip');

if (comment_help) {
  comment_help.onclick = function() {
    document.querySelector('.comment-info').classList.toggle('show');
  };
}


/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });

  });
}

/**
 * Redirect return from create account
 */
function koti_set_cookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
function koti_get_cookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}
function koti_delete_cookie(name) { koti_set_cookie(name, '', -1); }
function koti_maybe_redirect_return_from_registration() {
  var url = koti_get_cookie('luotunnukset_return');
  // has url and is not in registration view
  if (url !== null && window.location.pathname.indexOf('/luotunnukset/') === -1 && document.body.classList.contains('logged-in')) {
    koti_delete_cookie('luotunnukset_return');
    window.location.replace(decodeURIComponent(url));
  }
}
koti_maybe_redirect_return_from_registration();

/**
 * Make room for sidebar banners
 */

function koti_make_room_for_sidebar_banners() {

  var sidebar_elements = document.querySelectorAll('.container__side .sidebar-element');

  // ads are on every third place
  var order = 1;
  for (var i = 0; i < sidebar_elements.length; ++i) {
    if (!sidebar_elements[i].classList.contains('js-banner-container')) {
      sidebar_elements[i].style.order = order;
      if ((order + 1) % 3 === 0) {
        order = order + 2;
      } else {
        order = order + 1;
      }
    }

  }

}
koti_make_room_for_sidebar_banners();

/**
 * Move banner inside container
 */

function koti_get_first_non_empty_sibling_upwards(el) {
  do {
    el = el.previousSibling;
  } while (el && el.nodeType !== 1);
  return el;
}

function koti_get_nth_paragraph(el, nth) {
  let i = 1;
  do {
    el = el.nextSibling;
    if (el && el.nodeType && el.nodeType === 1 && el.tagName === 'P') {
      i++;
    }
  } while (el && i < nth);
  if (i === nth) {
    return el;
  }
  return false;
}

function koti_set_content_banner() {

  // get container that ads will be moved into
  var container_to_move = document.querySelector('.js-set-banner');

  // gather all available banners
  var banner_1_to_move    = document.getElementById('js-content-banner');
  var banner_2_to_move    = document.getElementById('js-content-banner-2');
  var banners_to_move = [];
  if (banner_1_to_move) {
    banners_to_move.push(banner_1_to_move);
  }
  if (banner_2_to_move) {
    banners_to_move.push(banner_2_to_move);
  }

  // move banners inside manually set places
  var manual_placeholders = document.querySelectorAll('.manual-banner');
  for (var i = 0; i < manual_placeholders.length; i++) {
    if (banners_to_move.length > 0) {
      manual_placeholders[i].appendChild(banners_to_move.shift());
    }
  }

  // move rest of bannes by automatic logic if moving is required
  if (container_to_move) {

    var titles = document.querySelectorAll('.js-set-banner > h2');
    var contents = container_to_move.children;
    var autoplace, position;

    for (var j = 0; j < banners_to_move.length; j++) {

      // 1st banner
      if (j === 0) {
        if (1 in titles) {
          // before 2nd title if exists
          position = 'before';
          autoplace = koti_get_first_non_empty_sibling_upwards(titles[1]);
        } else {
          // before 5th paragraph
          position = 'after';
          autoplace = koti_get_nth_paragraph(contents[0], 5);
        }
      }

      // 2nd banner
      if (j === 1) {
        if (3 in titles) {
          // before 4th heading if exists
          position = 'before';
          autoplace = koti_get_first_non_empty_sibling_upwards(titles[3]);
        } else {
          // before 12th paragraph
          position = 'after';
          autoplace = koti_get_nth_paragraph(contents[0], 12);
        }
      }

      if (autoplace) {
        if (position === 'after') {
          autoplace.parentNode.insertBefore(banners_to_move[j], autoplace.nextSibling);
        } else {
          autoplace.parentNode.insertBefore(banners_to_move[j], autoplace);
        }
      }

    }
  }

}

koti_set_content_banner();

/**
 * Sticky navigation on scroll
 */
var scroll_position = 0;
window.addEventListener('scroll', function() {

  var menu = document.getElementById('sticky-header');
  if (menu) {

    // no changes if mobile menu is open
    if (menu.classList.contains('active') && Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < desktop_min_width) {
      menu.classList.remove('sticky-header--visible');
      return;
    }

    var difference = Math.abs(pageYOffset - scroll_position);
    if (pageYOffset >= 240) {
      if (difference > 8) {
        // show sticky only when scroll upwards and at least 500px from top
        if (pageYOffset >= 240 && pageYOffset <= scroll_position) {
          menu.classList.add('sticky-header--visible');
        } else {
          if (menu.classList.contains('sticky-header--visible')) {
            menu.classList.remove('sticky-header--visible');
          }
        }
      }
    }
  }

  // quick exit if were are on top
  if (pageYOffset < 240) {
    menu.classList.remove('sticky-header--visible');
  }

  scroll_position = pageYOffset;
});

// dropdown
var dropdown_buttons = document.querySelectorAll('.dropdown__button');

if (dropdown_buttons) {
  for (var i = 0; i < dropdown_buttons.length; i++) {
    dropdown_buttons[i].addEventListener('click', function(e) {
      e.preventDefault();

      // get all .dropdown elements from the document
      var dropdowns = document.querySelectorAll('.dropdown');
      for (var j = 0; j < dropdowns.length; j++) {
        // toggle active class
        dropdowns[j].classList.toggle('dropdown--active');
      }
    });
  }
}

/**
 * Auto-move to payment
 */
function kt_add_anchors_to_my_account() {

  var tabs = document.querySelectorAll('.woocommerce-MyAccount-navigation a');
  if (tabs.length > 0) {
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].href = tabs[i].href + '#verkkomaksut';
    }
  }

}
kt_add_anchors_to_my_account();
